import api from './api'
export default {
    get: function(parms) {
      return api.get('invoice/get',{
        params: parms
        })
    },
    getList: function(parms) {
      return api.get('invoice/get/list',{
        params: parms
        })
    },
  }